import cx from "classnames";

const getAssociatedSectionHeaderId = (tabData) => {
    const associatedPageId = tabData?.map((tab) => {
        const { id } = tab;
        if (id === "credit-tab" || id === "echeck-tab") {
            return "aria-payment-page-header";
        }
        if (id === "individual-tab" || id === "company-tab") {
            return "aria-details-page-header";
        }
        if (id === "one-time" || id === "ongoing") {
            return "aria-gift-page-header";
        }
        return "";
    });
    return associatedPageId[0];
};

const getTabNavButtonClasses = (size, activeTab, index) =>
    cx(
        "tabs__tab",
        "qg-vendor-tab",
        `tabs__tab--${size}`,
        "-cursor--pointer",
        "-padding-top--15",
        activeTab === index ? "tabs__tab--active" : "",
    );

const getIndicatorClasses = (tabData, activeTab) =>
    cx(
        "tabs__indicator",
        `tabs__indicator--tabs-${tabData?.length}`,
        `tabs__indicator--active-tab-${activeTab + 1}-of-${tabData?.length}`,
    );

export {
    getAssociatedSectionHeaderId,
    getTabNavButtonClasses,
    getIndicatorClasses,
};
